import { render, staticRenderFns } from "./ameldings-new.vue?vue&type=template&id=25af3a18&scoped=true&"
import script from "./ameldings-new.vue?vue&type=script&lang=ts&"
export * from "./ameldings-new.vue?vue&type=script&lang=ts&"
import style0 from "./ameldings-new.vue?vue&type=style&index=0&id=25af3a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25af3a18",
  null
  
)

export default component.exports